import React, { useState } from 'react';
import WeeklySales from './WeeklySales';
import {
  Row,
  Col,
  Card,
  Button,
  Modal,
  CloseButton,
  Image
} from 'react-bootstrap';

import TotalOrder from './TotalOrder';
import MarketShare from './MarketShare';

import Select from 'react-select';
import ProductShare from '../we-raise-common/ProductShare/ProductShare';
import {
  weAddWedgitData,
  weGreetingItems,
  weMarketShare,
  weNotificationsDashBoard,
  weOrganizerOptions,
  weShoppingCartItems,
  weTableData,
  weTotalOrder,
  weWeeklySalesData
} from 'data/weraise-data/dashboard-data';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import ShoppingCart from '../we-raise-common/ShoppingCart';
import CustomAdvanceTable from 'components/common/advance-table/CustomAdvanceTable';
import SoftBadge from 'components/common/SoftBadge';
import Greetings from '../we-raise-common/Greetings';
import GreetingCard from '../we-raise-common/greetings/GreetingCard';
import userConfig from 'assets/img/we-raise-images/user-cog.png';
import TableRowAction from 'components/common/TableRowAction';

export const columns = [
  {
    accessor: 'name',
    Header: 'Donar',
    cellProps: {
      className: 'py-2'
    }
  },
  {
    accessor: 'email',
    Header: 'Email',
    cellProps: {
      className: 'py-2'
    },
    Cell: rowData => {
      const { email } = rowData.row.original;
      return <a href={'mailto:' + email}>{email}</a>;
    }
  },
  {
    accessor: 'description',
    Header: 'Donation Description',
    cellProps: {
      className: 'fw-medium py-2'
    }
  },
  {
    accessor: 'score',
    Header: 'Donor Score',
    cellProps: {
      className: 'fw-medium py-2'
    },
    Cell: rowData => {
      return (
        <SoftBadge pill bg={rowData.row.original.variant} className="me-2">
          {rowData.row.original.score}
        </SoftBadge>
      );
    }
  },
  {
    accessor: 'amount',
    Header: 'Amount',
    cellProps: {
      className: 'py-2'
    }
  },
  {
    accessor: 'id',
    Header: '',
    cellProps: {
      className: 'py-2 text-end'
    },
    disableSortBy: true,

    Cell: rowData => {
      const { id } = rowData.row;
      return (
        <TableRowAction
          onCLickEdit={() => console.log(id)}
          onCLickDelete={() => console.log(id)}
        />
      );
    }
  }
];

const Dashboard = () => {
  const [modalShow, setModalShow] = React.useState(false);

  const [value, setValue] = useState(null);

  return (
    <>
      <Row className="g-3 mb-3">
        <Col xs={12}>
          <Greetings data={weGreetingItems} showBg={false} />
        </Col>
        <Col xs={12}>
          <GreetingCard notifications={weNotificationsDashBoard} />
        </Col>
      </Row>
      <Row className="g-3">
        <Col lg={9}>
          <Row className="g-3 mb-3">
            <Col sm={6} xl={4}>
              <WeeklySales
                data={weWeeklySalesData}
                title="Monthly Donations"
                tooltipText="Calculated according to last week's sales"
                count="$47K"
                percent="+3.5%"
              />
            </Col>
            <Col sm={6} xl={4}>
              <ProductShare fontSize="fs-2" />
            </Col>
            <Col sm={6} xl={4}>
              <ProductShare
                fontSize="fs-2"
                bgColor="success"
                labels={['Active', 'Inactive']}
                chartData={[80, 20]}
                target="60%"
                title="Active Donors"
                current="46%"
                changes={5.5}
              />
            </Col>

            <Col sm={6} xl={4}>
              <MarketShare
                data={weMarketShare}
                title="Most Leads"
                radius={['100%', '80%']}
                showPercentage={false}
              />
            </Col>
            <Col sm={6} xl={4}>
              <TotalOrder data={weTotalOrder} font="fs-2" />
            </Col>
            <Col sm={6} xl={4}>
              <Card className="h-md-100">
                <Card.Body>
                  <Flex
                    alignItems="center"
                    justifyContent="center"
                    className="h-100"
                  >
                    <div className="text-center">
                      <Button
                        variant="light"
                        className="rounded-circle p-2 d-flex justify-content-center align-items-center mx-auto mb-2"
                        style={{ height: 52, width: 52 }}
                        onClick={() => setModalShow(true)}
                      >
                        <FontAwesomeIcon icon="plus" className="fs-2" />
                      </Button>
                      <p className="mb-0 fw-medium">Add Wedgit</p>
                    </div>
                  </Flex>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
        <Col lg={3} className="h-md-100">
          <ShoppingCart data={weShoppingCartItems} title="Projects Progress" />
        </Col>

        <Col md={12} xxl={12} className="h-md-100">
          <CustomAdvanceTable
            data={weTableData}
            columns={columns}
            title="Resent Donors"
          />
        </Col>
      </Row>

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="border-0">
          <Modal.Title id="contained-modal-title-vcenter">
            Add Wedgit
          </Modal.Title>

          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={() => setModalShow(false)}
          />
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="w-md-33">
            <label
              className="fs--1 fw-medium"
              id="aria-label"
              htmlFor="aria-example-input"
            >
              Category
            </label>
            <Select
              options={weOrganizerOptions}
              placeholder="Select..."
              classNamePrefix="react-select"
              value={value}
              onChange={value => setValue(value)}
            />
          </div>

          <hr />

          <Row style={{ maxHeight: 400 }} className="overflow-auto g-3 ">
            {weAddWedgitData?.map(data => (
              <Col md={6} key={data.id}>
                <Button
                  className="cursor-pointer bg-transparent border p-3 rounded-3 text-start"
                  onClick={() => console.log(data.id)}
                >
                  <Flex alignItems="center">
                    <Image
                      src={userConfig}
                      className="me-3"
                      height={77}
                      width={77}
                    />
                    <div>
                      <p className="mb-1 text-1100 fw-medium">{data.title}</p>
                      <p className="fs--1 mb-0 text-800">{data.details}</p>
                    </div>
                  </Flex>
                </Button>
              </Col>
            ))}
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Dashboard;
